import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator, ValidatorFn } from '@angular/forms';
import { Directive } from '@angular/core';

export function wholeCentsValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value === null || value === undefined || value === '') {
      return null; // emptiness is `required`'s concern, not this validator's
    }
    const cents = Number(value) * 100;
    const rounded = Math.round(cents);
    return Math.abs(cents - rounded) < 1e-6 ? null : { wholeCents: true };
  };
}

@Directive({
  selector: '[wholeCents]',
  providers: [{ provide: NG_VALIDATORS, useExisting: WholeCentsDirective, multi: true }],
  standalone: false
})
export class WholeCentsDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors | null {
    return wholeCentsValidator()(control);
  }
}
